import PagesHome from '@/views/pages/PagesHome'
import Page from '@/views/pages/Page'
import PageList from '@/views/pages/PageList'
import PageCreate from '@/views/pages/PageCreate'

export default {
  path: '/sidor',
  component: PagesHome,
  children: [
    {
      path: ':section',
      name: 'Pages',
      props: true,
      component: PageList,
      children: [
        {
          path: 'ny',
          name: 'createPage',
          props: true,
          component: PageCreate,
        },
      ],
    },
    {
      path: ':section/:id',
      name: 'Page',
      props: true,
      component: Page,
    },
  ],
}
